import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import {
  storeTypesArray,
  toolsArray,
  dataPointsArray,
  announcedOrUnannouncedArray,
  locationListSourceArray,
  timeConstraintsMaxLength,
} from './SharedConstants';

// Options for multi-select and dropdown fields
const coverageArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'FullInventory', label: 'Full inventory' },
  { value: 'SelectedCategories', label: 'Selected categories' },
  { value: 'Other', label: 'Other' },
];

const specialLocationsArray = [
  { value: 'Nevada', label: 'Nevada' },
  { value: 'Hawaii', label: 'Hawaii' },
  { value: 'Alaska', label: 'Alaska' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'HongKong', label: 'HongKong' },
  { value: 'China mainland', label: 'China mainland' },
  { value: 'Macao', label: 'Macao' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'Cambodia', label: 'Cambodia' },
];

const locationTypeArray = [
  { value: 'Metropolitan', label: 'Metropolitan' },
  { value: 'Rural', label: 'Rural' },
  { value: 'Suburbs', label: 'Suburbs' },
  { value: 'Other', label: 'Other' },
];

const inventoryAuditsPages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InventoryAudits,
    fields: [
      {
        fieldName: 'TimeConstraints',
        label: 'Visit Time Constraints (days/hours/etc)',
        className: 'col-12',
        type: InputTypesEnum.Text,
        maxLength: timeConstraintsMaxLength,
      },
      {
        fieldName: 'TypeOfStores',
        label: 'Type of stores',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: storeTypesArray,
      },
      {
        fieldName: 'Coverage',
        label: 'Coverage',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(coverageArray.map((c) => c.label)),
      },
      {
        fieldName: 'EstimatedTimePerAudit',
        label: 'Estimated time per audit (in minutes)',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'Tools',
        label: 'Tools',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: toolsArray,
      },
      {
        fieldName: 'DataPoints',
        label: 'Data points',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(dataPointsArray.map((d) => d.label)),
      },
      {
        fieldName: 'AnnouncedOrUnannounced',
        label: 'Announced or Unannounced?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(announcedOrUnannouncedArray.map((a) => a.label)),
      },
      {
        fieldName: 'LetterOfAuthorizationRequired',
        label: 'Letter of Authorization Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
      {
        fieldName: 'PhotosReqd',
        label: 'Photos required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhotosDescription',
        label: 'Please describe photos needed',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PhotosReqd !== 'true',
      },
      {
        fieldName: 'CallingAheadRequired',
        label: 'Calling ahead of audit required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'MaxDeliveryAfterShop',
        label: 'Time to Deliver Evaluation to Client',
        className: 'col-12',
        type: InputTypesEnum.MaxDeliveryAfterShop,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
    ],
  },
  {
    label: 'Location Details',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InventoryAudits,
    fields: [
      {
        fieldName: 'SpecialLocations',
        label: 'Select Special Locations if Applicable',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: specialLocationsArray,
      },
      {
        fieldName: 'LocationType',
        label: 'Location Type (select all that apply)',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: locationTypeArray,
      },
      {
        fieldName: 'LocationTypeDetails',
        label: 'Location Type Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.LocationType || !item.LocationType.includes('Other'),
      },
      {
        fieldName: 'LocationListSource',
        label: 'Location List Source',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationListSourceArray.map((l) => l.label)),
      },
    ],
  },
];

export default inventoryAuditsPages;
